// extracted by css-extract-rspack-plugin
export default {"cls1":"CitingSourcesCard-cls1_S_B","cls2":"CitingSourcesCard-cls2_Eh7 CitingSourcesCard-cls1_S_B"};